import React, {useState, useEffect} from 'react'

import {
    Box,
    Text,
    Image,
    Accordion,
    AccordionItem,
    AccordionButton,
    AccordionPanel,
    AccordionIcon,

    /* Hooks */
    useBreakpointValue
} from '@salesforce/retail-react-app/app/components/shared/ui'
import { getAssetUrl } from '@salesforce/pwa-kit-react-sdk/ssr/universal/utils'

/* Styles */
import { useMyRewardsStyles } from '../styles/myRewardsStyles'

/* Icons */
import { ChevronDownCheckout } from '../../../components/icons'

/* Hooks */
import { useOptimizely } from '../../../contexts/optimizely-context'
import useDetectDevice from '../../../hooks/use-detect-device'

/* Utils */
import { generateStyles, getHideStyles } from '../../../components/optimizely/utils/utils'

const LoyaltyProgramMobile = () => {
    const { rewardPageBlock } = useOptimizely()
    const { isMacOS, isMacOSChrome, isSafari, isAndroid } = useDetectDevice()
    const styles = useMyRewardsStyles()
    const lpStyle = styles?.components?.loyaltyProgram
    const [cmsData, setCmsData] = useState(null)

    const breakpointTitle = useBreakpointValue({
        base: cmsData?.title?.mobileText,
        md: cmsData?.title?.tabletText,
        lg: cmsData?.title?.desktopText
    })

    const hardCodedDataMobile = {
        title: {
            mobileText: 'Garage Collectif <span class="highlighted">benefits</span>',
            tabletText: 'What the Garage Collectif Can do <span class="highlighted">For You</span>',
            desktopText: 'What the Garage Collectif Can do <span class="highlighted">For You</span>',
        },
        levels: [{
            name: 'Creator',
            description: 'Free to join',
            background: '#F59ED1'
        }, {
            name: 'Muse',
            description: '300 points',
            background: '#F361B8'
        }, {
            name: 'Icon',
            description: '600 points',
            background: '#AC0967'
        }],
        tabs: [{
            name: 'The perks',
            contents: [{
                name: 'A special birthday gift from us',
                description: 'Available both in-store and online with a minimum purchase of $50+ on regular priced items!',
                cards: [{
                    icon: getAssetUrl('static/img/my-rewards/gift.svg'),
                    text: '$5',
                    background: '#FDECF6'
                }, {
                    icon: getAssetUrl('static/img/my-rewards/gift.svg'),
                    text: '$15',
                    background: '#FDDFF1'
                }, {
                    icon: getAssetUrl('static/img/my-rewards/gift.svg'),
                    text: '$25',
                    background: '#EECEE1'
                }]
            }, {
                name: 'Exclusive member prices & special offers',
                description: 'Garage Collectif members get special offers on select items throughout the year.',
                cards: [{
                    icon: getAssetUrl('static/img/my-rewards/creator.svg'),
                    text: null,
                    background: '#FDECF6'
                }, {
                    icon: getAssetUrl('static/img/my-rewards/muse.svg'),
                    text: null,
                    background: '#FDDFF1'
                }, {
                    icon: getAssetUrl('static/img/my-rewards/icon.svg'),
                    text: null,
                    background: '#EECEE1'
                }]
            }, {
                name: 'Free shipping on your online orders',
                description: 'Garage Collectif members are eligible for free shipping on their orders depending on their tier.',
                cards: [{
                    icon: null,
                    text: '$50+',
                    background: '#FDECF6'
                }, {
                    icon: null,
                    text: '$40+',
                    background: '#FDDFF1'
                }, {
                    icon: null,
                    text: '$10+',
                    background: '#EECEE1'
                }]
            }]
        }, {
            name: 'The points',
            contents: [{
                name: 'Earn Points by Shopping & More',
                description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer nec odio. Praesent libero. Sed cursus ante dapibus diam.',
                cards: [{
                    icon: getAssetUrl('static/img/my-rewards/creator.svg'),
                    text: null,
                    background: '#FDECF6'
                }, {
                    icon: getAssetUrl('static/img/my-rewards/muse.svg'),
                    text: null,
                    background: '#FDDFF1'
                }, {
                    icon: getAssetUrl('static/img/my-rewards/icon.svg'),
                    text: null,
                    background: '#EECEE1'
                }]
            }, {
                name: '$5 Off When You Reach 150 Points',
                description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer nec odio. Praesent libero. Sed cursus ante dapibus diam.',
                cards: [{
                    icon: getAssetUrl('static/img/my-rewards/creator.svg'),
                    text: null,
                    background: '#FDECF6'
                }, {
                    icon: getAssetUrl('static/img/my-rewards/muse.svg'),
                    text: null,
                    background: '#FDDFF1'
                }, {
                    icon: getAssetUrl('static/img/my-rewards/icon.svg'),
                    text: null,
                    background: '#EECEE1'
                }]
            }, {
                name: 'Double-Point Days',
                description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer nec odio. Praesent libero. Sed cursus ante dapibus diam.',
                cards: [{
                    icon: null,
                    text: null,
                    background: '#FDECF6'
                }, {
                    icon: getAssetUrl('static/img/my-rewards/muse.svg'),
                    text: null,
                    background: '#FDDFF1'
                }, {
                    icon: getAssetUrl('static/img/my-rewards/icon.svg'),
                    text: null,
                    background: '#EECEE1'
                }]
            }]
        }, {
            name: 'The Extras',
            contents: [{
                name: 'Surprise Offers & Experiences',
                description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer nec odio. Praesent libero. Sed cursus ante dapibus diam.',
                cards: [{
                    icon: getAssetUrl('static/img/my-rewards/creator.svg'),
                    text: null,
                    background: '#FDECF6'
                }, {
                    icon: getAssetUrl('static/img/my-rewards/muse.svg'),
                    text: null,
                    background: '#FDDFF1'
                }, {
                    icon: getAssetUrl('static/img/my-rewards/icon.svg'),
                    text: null,
                    background: '#EECEE1'
                }]
            }, {
                name: 'Invites to Exclusive Collectif-Only Events',
                description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer nec odio. Praesent libero. Sed cursus ante dapibus diam.',
                cards: [{
                    icon: null,
                    text: null,
                    background: '#FDECF6'
                }, {
                    icon: getAssetUrl('static/img/my-rewards/muse.svg'),
                    text: null,
                    background: '#FDDFF1'
                }, {
                    icon: getAssetUrl('static/img/my-rewards/icon.svg'),
                    text: null,
                    background: '#EECEE1'
                }]
            }, {
                name: 'Customer Service Priority',
                description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer nec odio. Praesent libero. Sed cursus ante dapibus diam.',
                cards: [{
                    icon: null,
                    text: null,
                    background: '#FDECF6'
                }, {
                    icon: null,
                    text: null,
                    background: '#FDDFF1'
                }, {
                    icon: getAssetUrl('static/img/my-rewards/icon.svg'),
                    text: null,
                    background: '#EECEE1'
                }]
            }]
        }]
    }

    const cmsDataModel = (rewardPageBlockData) => {
        return {
            title: {
                mobileText: rewardPageBlockData?.BenefitsResponsiveText?.Expanded?.MobileText,
                tabletText: rewardPageBlockData?.BenefitsResponsiveText?.Expanded?.TabletText,
                desktopText: rewardPageBlockData?.BenefitsResponsiveText?.Expanded?.DesktopText,
                ResponsiveTextBlockTextStyle: rewardPageBlockData?.BenefitsResponsiveText?.Expanded?.ResponsiveTextBlockTextStyle
            },
            levels: rewardPageBlockData?.BenefitsLevelBanner?.map(item => {
                const expanded = item.ContentLink.Expanded;
                return {
                    name: expanded.Title,
                    description: expanded.Description,
                    background: expanded.BackgroundColorOverride,
                    titleStyle: expanded.RewardBenefitsLevelTitleStyle,
                    descriptionStyle: expanded.RewardBenefitsLevelDescriptionStyle
                };
            }),
            tabs: rewardPageBlockData?.BenefitsSectionList?.map(section => {
                const expanded = section.ContentLink.Expanded;

                return {
                    name: expanded.Title,
                    titleStyle: expanded.RewardSectionBlockTitleStyle,
                    contents: expanded.RewardSectionTileList.map(tile => {
                        const tileExpanded = tile.ContentLink.Expanded;

                        return {
                            name: tileExpanded.Title,
                            description: tileExpanded.Description,
                            titleStyle: tileExpanded.RewardSectionTileBlockTitleStyle,
                            descriptionStyle: tileExpanded.RewardSectionTileBlockDescriptionStyle,
                            cards: tileExpanded.InfoTileList.map(info => {
                                const infoExpanded = info.ContentLink.Expanded;

                                return {
                                    icon: infoExpanded.IconMedia?.Expanded?.Url,
                                    text: infoExpanded.Title || null,
                                    background: infoExpanded.BackgroundColorOverride || '',
                                    titleStyle: infoExpanded.InfoTileBlockTitleStyle,
                                    titleBorderColor: infoExpanded.TitleBorderColor,
                                    titleBorderWidth: infoExpanded.TitleBorderWidth
                                };
                            })
                        };
                    }),
                    HideOnDevices: expanded.HideOnDevices
                };
            })
        }
    }

    useEffect(() => {
        if (rewardPageBlock) {
            setCmsData(cmsDataModel(rewardPageBlock))
        } else {
            setCmsData(hardCodedDataMobile)
        }
    }, [rewardPageBlock])

    const badgePadding = {
        ...isMacOS && {
            p: '0.4em 8px 0.4em',
        },
        ...isSafari && {
            p: '0.4em 8px 0.2em',
        },
        ...isAndroid && {
            p: '0.4em 8px 0.4em',
        },
        ...isMacOSChrome && {
            p: '0.5em 8px 0.35em',
        }
    }

    return (
        <Box>
            <Box {...lpStyle.heading}>
                <Box
                    {...generateStyles(cmsData?.title?.ResponsiveTextBlockTextStyle, { ...styles.sectionTitle })}
                    sx={styles.highlighted}
                    dangerouslySetInnerHTML={{ __html: breakpointTitle }} />
                <Box {...lpStyle.levels}>
                    {cmsData?.levels?.map((level, indexLevel) => {
                        return (
                            <Box {...lpStyle.level} backgroundColor={level.background} key={`loyaltyProgramLevel${indexLevel}`}>
                                <Text {...generateStyles(level?.titleStyle, { ...lpStyle.levelName })}>
                                    {level.name}
                                </Text>
                                <Text {...generateStyles(level?.descriptionStyle, { ...lpStyle.levelDescription })}>
                                    {level.description}
                                </Text>
                            </Box>
                        )
                    })}
                </Box>
            </Box>

            <Accordion defaultIndex={[0]} allowMultiple>
                {cmsData?.tabs?.map((tab, tabIndex) => {
                    const hideStyles = getHideStyles(tab.HideOnDevices)

                    return (
                        <AccordionItem {...lpStyle.accItem} key={`loyaltyProgramMobileTab${tabIndex}`} {...hideStyles}>
                            <AccordionButton data-testid={`loyalty-program-accordion-button-${tabIndex}`} {...lpStyle.accBtn}>
                                <Box as='span' {...generateStyles(tab.titleStyle, { ...lpStyle.accTitle })}>
                                    {tab.name}
                                </Box>
                                <AccordionIcon as={ChevronDownCheckout} />
                            </AccordionButton>
                            <AccordionPanel {...lpStyle.accPanel} key={`loyaltyProgramMobileTabPanel${tabIndex}`}>
                                {tab?.contents?.map((content, contentIndex) => {
                                    return (
                                        <Box key={`loyaltyProgramContent${contentIndex}`}>
                                            <Text {...generateStyles(content.titleStyle, { ...lpStyle.contentName })}>
                                                {content.name}
                                            </Text>
                                            <Text {...generateStyles(content.descriptionStyle, { ...lpStyle.contentDescription })}>
                                                {content.description}
                                            </Text>
                                            {content?.cards.length > 0 &&
                                                <Box {...lpStyle.cards} key={`loyaltyProgramCards${contentIndex}`}>
                                                    {content?.cards.map((card, cardIndex) => {
                                                        return (
                                                            <Box {...lpStyle.card} backgroundColor={card.background} key={`loyaltyProgramCard${cardIndex}`}>
                                                                {card?.icon &&
                                                                    <Image {...lpStyle.cardIcon} src={card.icon} alt='Icon' />
                                                                }
                                                                {card?.text &&
                                                                    <Text {...generateStyles(card.titleStyle, { ...lpStyle.cardText })}
                                                                        {...(card?.titleBorderColor || card?.titleBorderWidth) && {
                                                                            border: `${card?.titleBorderWidth || '1px'} solid`,
                                                                            borderColor: card?.titleBorderColor || 'black',
                                                                            p: '1px 8px 4px',
                                                                            lineHeight: '100%',
                                                                            ...badgePadding
                                                                        }}>
                                                                        {card.text}
                                                                    </Text>
                                                                }
                                                            </Box>
                                                        )
                                                    })}
                                                </Box>
                                            }
                                        </Box>
                                    )
                                })}
                            </AccordionPanel>
                        </AccordionItem>
                    )
                })}
            </Accordion>
        </Box>
    )
}

export default LoyaltyProgramMobile
